import { ensureFreshAlgoliaKeys } from '../support/algolia/algolia-keys-service';

/**
 * Clears stored Algolia keys (localStorage) and fetches fresh keys.
 * Call this when Algolia returns 401 (e.g. validUntil expired) so the next request uses new keys.
 * This is used as a reactive fallback when proactive refresh misses an edge case.
 */
export const clearAlgoliaKeysAndRefresh = async () => {
  // Clear localStorage if available (the manager uses localStorage)
  if (typeof localStorage !== 'undefined') {
    localStorage.removeItem('algoliaKeys');
  }
  // Force a fresh refresh via the managed service
  await ensureFreshAlgoliaKeys({ force: true });
};
